import { IDocumentEditable } from "..";
import { IItem } from "../../../../domain/document/items";

export abstract class AbstractDocumentItemInitializer<T> {
  constructor(private readonly _document: IDocumentEditable, private readonly _instanceOf: (s: any) => s is T) {}

  initialize(isQuoting: boolean = false): void {
    for (let itemSetId = 0; itemSetId < this._document.itemSets.length; itemSetId++) {
      const items = this._document.itemSets[itemSetId].items;
      for (const item of items) {
        if (this._instanceOf(item)) {
          this.initializeItem(item, update => {
            const cloned = item.clone() as IItem & T;
            update(cloned);
            this._document.updateItem(cloned, {
              itemSetId,
              isQuoting,
            });
          });
        }
      }
    }
  }

  protected abstract initializeItem(source: IItem & T, update: (u: (s: IItem & T) => void) => void): void;
}
